import { catchError, EMPTY, map, switchMap, tap, of } from "rxjs";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { API } from "../../shared/api";
import {
    createRemarkData,
    createRemarkDataError,
    createRemarkDataSuccess,
    fetchRemarkData,
    fetchRemarkDataError,
    fetchCurrentAndNextYearTrafficData,
    fetchCurrentYearTrafficData,
    fetchTrafficDataError,
    setRemarkData,
    updateRemarkData,
    updateRemarkDataError,
    updateRemarkDataSuccess,
    updateTrafficData,
} from "./createoredit.action";
import { DeleteModalComponent } from "../../admin/deleteModal.component";
import { MatDialog } from "@angular/material/dialog";
import { NotificationService } from "../../service/notification.service";

@Injectable()
export class CreateOrEditEffects {

    constructor(
        private action$: Actions,
        private dialog: MatDialog,
        private api: API,
        private router: Router,
        private notificationService: NotificationService
    ) {}

    fetchCurrentAndNextYearTrafficData$ = createEffect(() => this.action$.pipe(
        ofType(fetchCurrentAndNextYearTrafficData),
        switchMap(() => this.api.getCurrentAndNextYearTrafficData().pipe(
            map(remarksData => {
                if (remarksData.httpCode === 200) {
                    return updateTrafficData({ trafficData: remarksData.data });
                } else {
                    return fetchCurrentYearTrafficData();
                }
            }),
            catchError((error) => {
                console.error('Error fetching current and next year traffic data:', error);
                this.notificationService.showError('Kunde inte ladda trafikdata för innevarande och nästa år');
                return of(fetchTrafficDataError({ error }));
            })
        ))
    ))

    fetchCurrentYearTrafficData$ = createEffect(() => this.action$.pipe(
        ofType(fetchCurrentYearTrafficData),
        switchMap(() => this.api.getCurrentYearTrafficData().pipe(
            map(remarksData => updateTrafficData({ trafficData: remarksData.data })),
            catchError((error) => {
                console.error('Error fetching current year traffic data:', error);
                this.notificationService.showError('Kunde inte ladda trafikdata för innevarande år');
                return of(fetchTrafficDataError({ error }));
            })
        ))
    ))

    fetchRemark$ = createEffect(() => this.action$.pipe(
        ofType(fetchRemarkData),
        switchMap(({ remarkId }) => this.api.getRemark(remarkId).pipe(
            map(remark => setRemarkData({ remark })),
            catchError((error) => {
                console.error('Error fetching remark data:', error);
                this.notificationService.showError('Kunde inte ladda anmärkning');
                return of(fetchRemarkDataError({ error }));
            })
        ))
    ))

    updateRemark$ = createEffect(() => this.action$.pipe(
        ofType(updateRemarkData),
        switchMap(({ remark }) => this.api.updateRemark(remark).pipe(
            switchMap(() => {
                this.notificationService.showSuccess('Anmärkning uppdaterad');
                this.router.navigate(['admin']);
                return of(updateRemarkDataSuccess());
            }),
            catchError((error) => {
                console.error('Error updating remark:', error);
                this.notificationService.showError('Kunde inte uppdatera anmärkning');
                return of(updateRemarkDataError({ error }));
            }),
        ))
    ));

    createRemark$ = createEffect(() => this.action$.pipe(
        ofType(createRemarkData),
        switchMap(({ remark }) => this.api.createRemark(remark).pipe(
            switchMap((response) => {
                this.notificationService.showSuccess('Anmärkning skapad');
                const remarkId = response.id || '';
                this.dialog.open(DeleteModalComponent, {
                    width: '400px',
                    data: {
                        title: 'Skapa undantag',
                        message: 'Vill du också skapa ett undantag för anmärkningen?',
                        noLabel: 'Nej',
                        yesLabel: 'Ja',
                    }
                }).afterClosed().subscribe(accepted => {
                    if (accepted && remarkId) {
                        this.router.navigate([`admin/edit/${remarkId}/exception-create`])
                    } else {
                        this.router.navigate(['admin'])
                    }
                });
                return of(createRemarkDataSuccess({ remarkId }));
            }),
            catchError((error) => {
                console.error('Error creating remark:', error);
                this.notificationService.showError('Kunde inte skapa anmärkning');
                return of(createRemarkDataError({ error }));
            }),
        ))
    ));

}